import React from 'react';
import Autosuggest from 'react-autosuggest';
import { withTheme } from 'styled-components';

import Icon from 'components/Icon';
import { connect } from 'react-redux';
import { updateDestination } from 'store/slices/searchBox';

const throttle = require('lodash/throttle');

class DestinationSearchInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            suggestions: [],
            value:
                props.term !== null ? props.term : '',
        };

        this.debouncedLoadSuggestions = throttle(
            this.onSuggestionsFetchRequested,
            500,
            { leading: false },
        );

        this.containerRef = React.createRef();
    }

    onChange = (event, { newValue }) => {
        this.setState({ value: newValue });
    };

    onSuggestionSelected = (event, { suggestion }) => {
        this.props.updateDestination({
            term: suggestion.value,
            property: suggestion.property ?? null,
            resort: suggestion.resort ?? null,
            destination: suggestion.destination,
            country: suggestion.country,
        });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        fetch(`${process.env.REACT_APP_API_URL}/search/text?${new URLSearchParams({ term: value })}`)
            .then((response) => response.json())
            .then((response) => {
                this.setState({ suggestions: response });
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({ value: null });
                } else {
                    throw error;
                }
            });
    };

    debouncedFetch = (value) => {
        this.debouncedLoadSuggestions(value);
    };

    onSuggestionsClearRequested = () => {
        this.setState({ suggestions: [] });
    };

    getSuggestionValue = (suggestion) => suggestion.value;

    boldString = (str, query) => {
        const n = str.toUpperCase();
        const q = query.toUpperCase();
        const x = n.indexOf(q);

        if (!q || x === -1) {
            return str;
        }

        const l = q.length;

        // eslint-disable-next-line react/no-danger
        return <span dangerouslySetInnerHTML={{ __html: `${str.substr(0, x)}<b class="bold">${str.substr(x, l)}</b>${str.substr(x + l)}` }} />;
    }

    renderSuggestion = (suggestion) => (
        <span>
            {this.boldString(suggestion.value, this.state.value)}
            {" "}
            {suggestion.type !== 'property' && (
                <span className="autocomplete-subtext">
                    (
                    {suggestion.count}
                    {' '}
                    properties)
                </span>
            )}
        </span>
    );

    renderSectionTitle = (section) => <strong>{section.type}</strong>;

    shouldRenderSuggestions = (value) => value.trim().length > 2;

    getSectionSuggestions = (section) => section.items;

    onClick = () => {
        if (this.props.browser.size !== 'lg' ) {
            if (typeof this.containerRef.current.scrollIntoView === "function") {
                setTimeout(() => this.containerRef.current.scrollIntoView({ behavior: 'smooth' }), 100);
            } else {
                setTimeout(() => window.scrollTo({top: 300}), 100);
            }
        }
    };

    render() {
        return (
            <div className={this.props.className} ref={this.containerRef}>
                <div className="icon-container">
                    <Icon type="search" width="22px" height="22px" colour={this.props.theme.colours.primary} />
                </div>
                <Autosuggest
                    suggestions={this.state.suggestions}
                    onSuggestionsFetchRequested={this.debouncedFetch}
                    onSuggestionsClearRequested={
                        this.onSuggestionsClearRequested
                    }
                    onSuggestionSelected={this.onSuggestionSelected}
                    shouldRenderSuggestions={this.shouldRenderSuggestions}
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={this.renderSuggestion}
                    multiSection
                    focusInputOnSuggestionClick={false}
                    getSectionSuggestions={this.getSectionSuggestions}
                    renderSectionTitle={this.renderSectionTitle}
                    inputProps={{
                        placeholder:
                            this.props.browser.size === 'sm'
                                ? 'Destination'
                                : 'Enter a destination or hotel',
                        value: this.state.value,
                        onChange: this.onChange,
                        onClick: this.onClick,
                    }}
                />
            </div>
        );
    }
}

const mapDispatchToProps = { updateDestination };
  
export default withTheme(connect(null, mapDispatchToProps)(DestinationSearchInput));
